module.exports = __webpack_public_path__ + "assets/wenjian.ae3811e7.svg";